import $ from 'jquery';


export default () => {
    
    if ($(window).width() <= 972) {
        $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();
            if (scroll > 10) {
                $('#scroll-content').addClass('show-header-bg');
            } else {
                $('#scroll-content').removeClass('show-header-bg');
            }
        });
    }

};



// WEBPACK FOOTER //
// ./scripts/libs/header-mobile.js